import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

import { IPropsType as IChatboxV2PropsType } from '../../../Routes/renderer/chatBoxV2'

interface IConfig extends Omit<IChatboxV2PropsType, 'type' | 'sendStoreId'> {
  enableChat: boolean
}

const defaultConfig: IConfig = {
  enableChat: false,
  agentCode: 'store-guest',
}

export default (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      case 'ghai_pop':
        return {
          ...defaultConfig,
          enableChat: true,
          hideFromNonExpoUsers: true,
        }

      default:
        return defaultConfig
    }
  }, [brand])
}
